import React from 'react';
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';
import { SegmentedControl } from './ui/SegmentedControl';
import { useTheme, type ColorMode } from '../contexts/ThemeContext';
export function AppearanceSetting() {
  const {
    mode,
    setMode
  } = useTheme();
  return <SegmentedControl<ColorMode> ariaLabel="Appearance" layoutId="appearance" className="flex w-full max-w-sm" value={mode} onChange={setMode} options={[{
    value: 'system',
    label: 'System',
    icon: <MonitorIcon className="h-4 w-4" data-id="element-47" data-mp="2o49exoadjfb5" />
  }, {
    value: 'light',
    label: 'Light',
    icon: <SunIcon className="h-4 w-4" data-id="element-48" data-mp="330qoc9z06jv2" />
  }, {
    value: 'dark',
    label: 'Dark',
    icon: <MoonIcon className="h-4 w-4" data-id="element-49" data-mp="2y1nhcjzgq3kg" />
  }]} data-id="element-46" data-mp="3gs58wl8k6t48" />;
}